import { Ruleset } from "@rosette/ts/src/business/game/Ruleset.js";
import { Path } from "@rosette/ts/src/util/Path.js";


export function getGameSettingsReadMorePath(settings: Ruleset | null): Path {
    if (settings === null)
        return new Path("/rules");

    const name = settings.getName();
    if (name === Ruleset.FINKEL.getName())
        return new Path("/rules#finkel");
    if (name === Ruleset.MASTERS.getName())
        return new Path("/rules#masters");
    if (name === Ruleset.BLITZ.getName())
        return new Path("/rules#blitz");

    return new Path("/rules");
}
